import { AlpineData, LivewireData, LivewireMethods } from "@/js/interfaces/Components/alpinejs/HardConfigurationIndex";
import { createAlpineLivewireComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'HardConfigurationIndex',
    component: (
        // Component parameters...
    ) => createAlpineLivewireComponent<AlpineData, LivewireData, LivewireMethods>({
        // Component properties ...
        displayCreateForm: false,
        createConfigKey: '',
        createConfigValue: '',

        editItemId: 0,
        editConfigValue: '',


        /**
         * Initialize the component
         */
        init() {
            // ...
        },

        toggleCreateForm(): void {
            this.displayCreateForm = !this.displayCreateForm;
        },

        createConfigEntry(): void {
            this.$wire.$call('createConfigEntry', this.createConfigKey, this.createConfigValue);
            this.createConfigKey = '';
            this.createConfigValue = '';
            this.displayCreateForm = false;
        },

        openEditionForm(id: number, value: string): void {
            this.editItemId = id;
            this.editConfigValue = value;
        },

        isEditingFormOpen(id: number): boolean {
            return id === this.editItemId;
        },

        saveModifications(): void {
            this.$wire.$call('updateConfigEntry', this.editItemId, this.editConfigValue);
            this.editItemId = 0;
            this.editConfigValue = '';
        },
    }),
};
